export interface HubPlatform {
  id: string;
  /** Small label rendered above the name, e.g. "TRAINING". */
  eyebrow?: string;
  name: string;
  url?: string;
  bullets: string[];
}

/** A platform without a configured URL is not shown at all, so an unset env var hides the card. */
const withConfiguredUrl = (list: HubPlatform[]) => list.filter(platform => !!platform.url);

export const getHubPlatforms = (): HubPlatform[] =>
  withConfiguredUrl([
    {
      id: "acp",
      name: "Assessment & Conferencing Platform",
      url: process.env.REACT_APP_HUB_URL_ACP,
      bullets: ["Send CCH for all students", "Administer and grade LC AE's", "Generate LC & EP Outputs"]
    },
    {
      id: "ecenter",
      name: "eCenter/Navigator",
      url: process.env.REACT_APP_HUB_URL_ECENTER,
      bullets: [
        "Set-up student programs",
        "Teachers use during student sessions",
        "Gather relevant information for Interim Conferences"
      ]
    },
    {
      id: "mcp",
      name: "MCP",
      url: process.env.REACT_APP_HUB_URL_MCP,
      bullets: [
        "Grow your business by driving inquiries through multiple marketing programs, which can improve profitability",
        "Opt in/out of campaigns"
      ]
    },
    {
      id: "fabric",
      name: "MS Fabric (Power BI)",
      url: process.env.REACT_APP_HUB_URL_FABRIC,
      bullets: ["Dynamic reporting", "Document notes directly on reports and share between staff members"]
    },
    {
      id: "scheduling",
      name: "Scheduling Tool",
      url: process.env.REACT_APP_HUB_URL_SCHEDULING,
      bullets: ["Schedule all student sessions", "Enter and see Teacher availability and schedules"]
    },
    {
      id: "tin",
      name: "Test Innovators (Admin Site)",
      url: process.env.REACT_APP_HUB_URL_TIN,
      bullets: ["Lock and unlock tests for review", "Unhide sections results and scores"]
    },
    {
      id: "teams",
      name: "MS Teams",
      url: process.env.REACT_APP_HUB_URL_TEAMS,
      bullets: [
        "Hold online conferences",
        "Attend corporate virtual events",
        "Conduct online student sessions (if not on Virtual Classroom/Scheduling Tool)"
      ]
    },
    {
      id: "sharepoint",
      name: "SharePoint",
      url: process.env.REACT_APP_HUB_URL_SHAREPOINT,
      bullets: ["Online repository of HLC forms", "Curriculum Inventory", "Order Forms"]
    }
  ]);

export const getHubTrainingPlatforms = (): HubPlatform[] =>
  withConfiguredUrl([
    {
      id: "training-lcos",
      eyebrow: "TRAINING",
      name: "LCOS",
      url: process.env.REACT_APP_HUB_URL_TRAINING_LCOS,
      bullets: ["Sandbox environment to practice new functionality being released"]
    },
    {
      id: "training-acp",
      eyebrow: "TRAINING",
      name: "Assessment & Conferencing Platform",
      url: process.env.REACT_APP_HUB_URL_TRAINING_ACP,
      bullets: ["Send CCH for all students", "Administer and grade LC AE's", "Generate LC & EP Outputs"]
    },
    {
      id: "training-ecenter",
      eyebrow: "TRAINING",
      name: "eCenter/Navigator",
      url: process.env.REACT_APP_HUB_URL_TRAINING_ECENTER,
      bullets: [
        "Set-up student programs",
        "Teachers use during student sessions",
        "Gather relevant information for Interim Conferences"
      ]
    },
    {
      id: "training-scheduling",
      eyebrow: "TRAINING",
      name: "Scheduling Tool",
      url: process.env.REACT_APP_HUB_URL_TRAINING_SCHEDULING,
      bullets: ["Schedule all student sessions", "Enter and see Teacher availability and schedules"]
    }
  ]);
